import crudApi from "@serie3/common/api/crudApi";

const endpoints = {
  revenue: "finance/revenue/",
};

const getRevenue = (year) => {
  return crudApi.getAll(endpoints.revenue + year);
};

const getRevenueByPayment = (year) => {
  return crudApi.getAll(endpoints.revenue + year + "/payment");
};

export default { getRevenue, getRevenueByPayment, endpoints };
